import SectionRenderer from "../../../components/sections/SectionRenderer";

function PagePreview({ page, sections }) {
  const heroSection = sections.find(
    (section) => section.section_type === "hero"
  );

  const mainSections = sections.filter(
    (section) =>
      section.zone === "main" &&
      section.section_type !== "hero"
  );

  const sidebarSections = sections.filter(
    (section) => section.zone === "sidebar"
  );

  return (
      <div className="preview-box">
          <h3>Preview</h3>

          <div className="preview-page">
              {heroSection && <SectionRenderer section={heroSection} />}

              <div className="page-layout">
                  <main className="main-content">
                      {mainSections.map((section) => (
                          <SectionRenderer key={section.id || section.temp_id} section={section} />
                      ))}
                  </main>

                  <aside className="sidebar">
                      {sidebarSections.map((section) => (
                          <SectionRenderer key={section.id || section.temp_id} section={section} />
                      ))}
                  </aside>
              </div>
          </div>
      </div>
  );
}

export default PagePreview;